import { initializeApp } from "firebase/app";
import { getFirestore, doc, getDoc, collection, getDocs, setDoc, updateDoc, query, where, limit, writeBatch } from "firebase/firestore";
import { getAuth, signOut, onAuthStateChanged } from "firebase/auth";
import { getAnalytics, isSupported as analyticsIsSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCbQ0HWEkdoCfzaJMVEnUQNGe1jx3GOQw8",
  authDomain: "timeoff-tracker-81143.firebaseapp.com",
  projectId: "timeoff-tracker-81143",
  storageBucket: "timeoff-tracker-81143.appspot.com",
  messagingSenderId: "273349082779",
  appId: "1:273349082779:web:f74df7bde43c11338e503e",
  measurementId: "G-8FSEFBF6X0",
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

export let analytics = null;
(async () => {
  try {
    if (await analyticsIsSupported()) analytics = getAnalytics(app);
  } catch {
    // ignore
  }
})();

console.log("🔥 Connected to Firebase Project:", app.options.projectId);

const DEV_HOOK_VERSION = "2026-01-27-D";

if (typeof window !== "undefined") {
  const hook = (window.__timeoff = window.__timeoff || {});

  hook.version = DEV_HOOK_VERSION;
  hook.app = app;
hook.setDoc = setDoc;
hook.updateDoc = updateDoc;
  hook.db = db;
  hook.auth = auth;

  hook.signOut = signOut;
  hook.onAuthStateChanged = onAuthStateChanged;

  hook.doc = doc;
  hook.getDoc = getDoc;
  hook.collection = collection;
  hook.getDocs = getDocs;
  hook.query = query;
  hook.where = where;
  hook.limit = limit;
  hook.writeBatch = writeBatch;

  hook.whoami = async () => {
    const u = auth.currentUser;
    if (!u) {
      console.log("No currentUser (not signed in).");
      return null;
    }
    const info = {
      uid: u.uid,
      email: u.email,
      emailVerified: u.emailVerified,
      providerData: u.providerData?.map((p) => ({
        providerId: p.providerId,
        uid: p.uid,
        email: p.email,
        displayName: p.displayName,
      })),
    };
    console.log("Signed in as:", info);
    return info;
  };

  hook.resetSession = async () => {
    try {
      await signOut(auth);
      console.log("Signed out. Reloading...");
    } catch (e) {
      console.error("Sign out failed:", e?.code, e?.message);
    } finally {
      window.location.href = `${window.location.pathname}?logout=1`;
    }
  };

  hook.testUserDoc = async () => {
    const u = auth.currentUser;
    if (!u) return console.log("No currentUser.");
    try {
      const snap = await getDoc(doc(db, "users", u.uid));
      console.log("users/{uid} read:", { exists: snap.exists(), data: snap.data() });
      return snap.data() || null;
    } catch (e) {
      console.error("users/{uid} READ failed:", e?.code, e?.message);
      return null;
    }
  };

  hook.testUsersByEmail = async (email) => {
    const emailLower = String(email || "").trim().toLowerCase();
    if (!emailLower) return console.log("Provide an email.");
    try {
      const qs = await getDocs(query(collection(db, "users"), where("emailLower", "==", emailLower), limit(5)));
      const rows = qs.docs.map((d) => ({ id: d.id, ...d.data() }));
      console.log("users lookup by emailLower:", rows);
      return rows;
    } catch (e) {
      console.error("users lookup failed:", e?.code, e?.message);
      return [];
    }
  };

  console.log("🧪 DEV HOOK VERSION:", DEV_HOOK_VERSION);
  console.log("🧪 Debug ready: window.__timeoff");
}
